import { adminClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
  basePath: "/api/auth",
  plugins: [adminClient()],
});

export const { signIn, signOut, useSession, requestPasswordReset, resetPassword } = authClient;

export type PlatformRole = "ir_admin" | "ir_publisher" | "ir_analyst" | "client";

export function isAdmin(role: string | undefined): boolean {
  return role === "ir_admin";
}
